var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDroplinkedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM13.2181 3.68276H15.9517V18.8483H14.6232L14.6205 18.8483H11.1911C8.56674 18.8483 6.43448 16.7148 6.43448 14.089C6.43448 11.4633 8.56674 9.32982 11.1911 9.32982C11.9158 9.32982 12.6029 9.49252 13.2181 9.78335V3.68276Z",
    fill: "#2BCFA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1911 12.0377C10.0703 12.0377 9.16814 12.9403 9.16814 14.0617C9.16814 15.1831 10.0703 16.0857 11.1911 16.0857H13.214V14.089C13.214 12.9676 12.3119 12.0377 11.1911 12.0377Z",
    fill: "#2BCFA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroplinkedLogo);
export default __webpack_public_path__ + "static/media/droplinked-logo.7b76cd266d59d8f6cc6ed8f5f2026821.svg";
export { ForwardRef as ReactComponent };